export enum CampaignApplicationStatusValues {
  PENDING = "pending",
  ACCEPTED = "accepted",
  REJECTED = "rejected",
  NOT_APPLIED = "not applied",
  ALL = "all",
}